// @flow
import type { Element } from 'react'
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import './styles.scss'
import SelectionList from '../selectionList/index'
import config from 'config'

export type selectorProps = {
  selectedFlatSize: string,
  selectedPriceRange: string,
  flatSizeChangeHandler: (
    selectedKey: string,
    event: SyntheticEvent<*>
  ) => void,
  priceRangeChangeHandler: (
    selectedKey: string,
    event: SyntheticEvent<*>
  ) => void
}

export default function Selector ({
  selectedFlatSize,
  selectedPriceRange,
  flatSizeChangeHandler,
  priceRangeChangeHandler
}: selectorProps): Element<any> {
  return (
    <div className='ui two column grid'>
      <div className='column'>
        <div className='ui sub header'>Wohnungsgrösse</div>
        <SelectionList
          activeItem={selectedFlatSize}
          clickHandler={flatSizeChangeHandler}
          items={config.flatSizeCategories}
        />
      </div>
      <div className='column'>
        <div className='ui sub header'>Budget für Miete (ohne Nebenkosten)</div>
        <SelectionList
          activeItem={selectedPriceRange}
          clickHandler={priceRangeChangeHandler}
          items={config.budgetCategories}
        />
      </div>
    </div>
  )
}
